import { render } from "./FugleTable.vue?vue&type=template&id=046565c9&scoped=true&ts=true"
import script from "./FugleTable.vue?vue&type=script&lang=ts"
export * from "./FugleTable.vue?vue&type=script&lang=ts"

import "./FugleTable.vue?vue&type=style&index=0&id=046565c9&lang=scss&scoped=true"
import "./FugleTable.vue?vue&type=style&index=1&id=046565c9&scoped=true&lang=css"
import "./FugleTable.vue?vue&type=style&index=2&id=046565c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046565c9"]])

export default __exports__